<script lang="ts">
    import type {NatsConnection, ConnectionOptions, Msg, NatsError} from "nats.ws";
    // @ts-ignore
    import {NatsNegConnection, NatsState} from "./natsneg"
    // @ts-ignore
    import {IceAgent, RandomUfrag, RTCFactory} from "./nttrtc/webrtc"
    import type {LocalInfo} from "./nttrtc/iface_discovery"
    import { onDestroy, onMount } from "svelte";
    import type { NatsViewerSession, W84Location } from "./natsviewersession";
    import IconButton from '@smui/icon-button';
    import Button from '@smui/button';
    import { bytesToString, stringToBytes } from "./natsnegcommon";
    import NatsViewerControls from "./NatsViewerControls.svelte";
    import type MapWindow from "./MapWindow.svelte";
    import type { Actor } from "../jmdb";

    interface Discovery {
        id: string
        role: string
        pubKey: string
    }
    export let debug: boolean
    export let title: string
    export let neg: NatsNegConnection
    export let peerPub = ""
    //export let localInfoGathered: Promise<LocalInfo>
    export let mapWindow: MapWindow
    export let isLeader = true
    export let disco: WebSocket
    export let myInfo: Actor

    //let localInfo: LocalInfo
    let oldPeerPub = ""
    let videoDisabled = false

    let natsState: NatsState = NatsState.NotConnected
    let videoTrack: HTMLVideoElement
    let audioTrack: HTMLAudioElement


    // const sleep = (milliseconds: number) => {
    //    return new Promise(resolve => setTimeout(resolve, milliseconds))
    // }

    let errorHandler = (err: any) => {
        console.log(err)
        natsState = NatsState.NotConnected
    }
    
    let rtcFactory = new RTCFactory()
    rtcFactory.provideDataStream()
    
    rtcFactory.provideTranceiver('video', {'direction': 'sendrecv'})
    rtcFactory.provideTranceiver('video', {'direction': 'sendrecv'})
    rtcFactory.provideTranceiver('audio', {'direction': 'sendrecv'})
    
    //let streamObj = null
    let onTrackHandler = (rawEv: Event) => {
        let ev: RTCTrackEvent = rawEv as RTCTrackEvent
        console.log(ev)
        if (ev.track.kind == "audio") {
            // TODO: audio stream
            console.log("Audio stream", ev)
            audioTrack.autoplay = true
            let mediaStream = new MediaStream([ev.track])
            audioTrack.srcObject = mediaStream
        } else {
            videoTrack.autoplay = true
            let mediaStream = new MediaStream([ev.track])
            videoTrack.srcObject = mediaStream
        }
        
    }

    let mapMarker: Marker | null = null

    let buttonColor = "black"

    let onLocationUpdated = (l: W84Location) => {
        if (l.p != "gps") {
            return
        }
        if (mapMarker == null) {
            mapMarker = mapWindow.createMarker(title)
            buttonColor = mapMarker.color.slice(0,7)
        }
        mapWindow.updateMarker(mapMarker, l)
    }


    let viewerSession: NatsViewerSession | null = null
    let negStatus = "not started"
    function startNeg(wantPeerPub: string, disco: WebSocket) {
        negStatus = "Collecting local cands"
        
        peerPub = wantPeerPub
        // Await connection updates
        neg.startNeg(peerPub, {
            factory: rtcFactory,
            //localInfo: localInfo,
            statusCb: (status) => {
                console.log("statusCb", status)
                negStatus = status
            },
            onTrack: onTrackHandler,
            disco: disco
        })
        .then((newViewerSession) => {
            viewerSession = newViewerSession
            viewerSession.connect()
            viewerSession.onLocationUpdate = onLocationUpdated
            natsState = NatsState.Connected
        })

        // localInfoGathered.then((li) => {
        //     localInfo = li
            
        // })
    }

    onMount(() => {
        console.log("conn", peerPub, oldPeerPub)
        if (peerPub != oldPeerPub) {
            oldPeerPub = peerPub
            startNeg(peerPub, disco)
        }
    })
    onDestroy(() => {
        viewerSession?.close()
        if (mapMarker != null && mapWindow != null) {
            mapWindow.removeMarker(mapMarker)
        }
    })

    let transitionEnabled = false
    let rotationDeg = 0
    let transitionTimer: number|undefined = undefined

    function viewRotate(){
        if (!videoTrack || rotationDeg % 180 == 0) {
            return 1;
        }
		return (0.0 + videoTrack.clientHeight) / videoTrack.clientWidth;
	}
    function rotate() {
        clearTimeout(transitionTimer)
        transitionEnabled = true
        
        rotationDeg = rotationDeg + 90
        transitionTimer = setTimeout(() => {
            transitionEnabled = false
            rotationDeg = rotationDeg % 360
        }, 600)
    }

    function onLocationClick() {
        mapWindow.setVisible(true)
        mapWindow.setDisplayMap(true)
        if (mapMarker != null) {
            mapWindow.centerOnMarker(mapMarker)
        }
    }

    let videoStatus = "unknown"
    let frameTimeoutInterval: number | null = null

    let resetFrameTimeout = () => {
        if (frameTimeoutInterval != null) {
            clearTimeout(frameTimeoutInterval)
        }
        if (videoStatus == "framestuck") {
            videoStatus = "playing"
        }
        frameTimeoutInterval = setTimeout(() => {
            videoStatus = "framestuck"
        }, 5000)
    }

    let setVideoDisabled = (disabled: boolean) => {
        videoDisabled = disabled
    }

    let angleMod = () => {
        return [5,0,10,3,7,2,5,8,4,6,9][(myInfo?.id || 0) % 10]
    }

</script>

<style>
    .trans {
        transition: all .5s linear;
    }
    video {
        max-width: 100%;
        height: 100%;
        vertical-align: bottom;
    }
    .videoContainer {
        position: relative;
        aspect-ratio: 16/9;
        text-align: center;
        overflow: hidden;
    }

    .vblock {
        display: inline-block;
        position: absolute;

        width: 101%;
        height: 101%;
        background-color: #2c3e50;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .vdisabled {
        display: inline-block;
        position: absolute;

        padding: 4em;
        background-color: #0007;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .lds-ring {
        display: inline-block;
        position: absolute;

        width: 80px;
        height: 80px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .lds-ring div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 64px;
        height: 64px;
        margin: 8px;
        border: 8px solid #fff;
        border-radius: 50%;
        animation: lds-ring 2.4s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: #2c3e50 transparent transparent transparent;
    }
    .lds-ring div:nth-child(1) {
        animation-delay: -0.9s;
    }
    .lds-ring div:nth-child(2) {
        animation-delay: -0.6s;
        }
    .lds-ring div:nth-child(3) {
        animation-delay: -0.3s;
    }
    @keyframes lds-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    .userOverlay {
        position: absolute;
        z-index: 1;
        width: 100%;
        aspect-ratio: 16/9;
        align-items: center;
        display: flex;
        justify-content: center;
        font-size: calc(var(--containerSize) * var(--leaderFrac) / var(--textLen) * 16 / 9 * 0.8);
        /* transform: rotate(-25deg); */
        /* color: #fff4; */
        cursor: default;
        user-select: none;
        font-family: 'Courier New', Courier, monospace;
    }



</style>
<Button color="primary" class="material-icons" on:click={rotate}><span class="material-icons">rotate_right</span></Button>
<b>{title}</b>
{#if mapMarker}
<span style="color: {buttonColor}; vertical-align: sub;" class="material-icons">location_on</span>
{/if}
{#if debug}
Neg Status: {negStatus}
{/if}
<br/>

<!-- <audio id="audioTrack" controls autoplay/> -->
<div class="videoContainer">
    {#if myInfo?.computedRights?.lprot.override && myInfo?.computedRights?.lprot.opacity != 0}
    <div style="color: rgba(255, 255, 255, {(myInfo?.computedRights?.lprot.opacity || 0) / 100}); --textLen: {Math.max((myInfo?.name || "").length, 4)}; transform: rotate({angleMod() + rotationDeg-25.0}deg) scale({viewRotate()});" class="userOverlay" class:trans={transitionEnabled}>{myInfo?.name}</div>
    {/if}

    <!-- svelte-ignore a11y-media-has-caption -->
    <video bind:this={videoTrack} 
    on:playing={() => videoStatus = "playing"} 
    on:pause={() => videoStatus = "pause"} 
    on:stalled={() => videoStatus = "stalled"} 
    on:emptied={() => videoStatus = "emptied"} 
    on:timeupdate={() => resetFrameTimeout()}
    class:trans={transitionEnabled} style="transform: rotate({rotationDeg}deg) scale({viewRotate()});" autoplay/>
    {#if videoDisabled}
        <div class="vblock"/>
        <div class="vdisabled">Video disabled. Re-enable in video controls.</div>
    {:else if videoStatus != "playing"}
        <div class="lds-ring"><div/><div/><div/><div/></div>
    {/if}
    <!-- svelte-ignore a11y-media-has-caption -->
    <audio bind:this={audioTrack} autoplay/>
    {#if isLeader}
    <div>
        {#if natsState == NatsState.Connected}
            <NatsViewerControls setVideoDisabled={setVideoDisabled} neg={neg} peerPub={peerPub} viewerSession={viewerSession} locationClick={onLocationClick}/>
        {/if}
    </div>
    {/if}
</div>
